// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-footer-index-module__ui-footer-Wln3pL {
  justify-content: center;
  padding: 30px 36px 20px;
  display: flex;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-footer": `------packages-components-bot-semi-src-components-ui-footer-index-module__ui-footer-Wln3pL`,
	"uiFooter": `------packages-components-bot-semi-src-components-ui-footer-index-module__ui-footer-Wln3pL`
};
export default ___CSS_LOADER_EXPORT___;
